import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { queueWant } from '../api/client.js';
import { djViewQueryKey } from '../api/queryKeys.js';

import type { ChannelId, DjView, PartySlug, TrackId } from '@mixwire/contracts';

type QueueWantVariables = {
  readonly slug: PartySlug;
  readonly channelId: ChannelId;
  readonly wantId: TrackId;
};

export const useQueueWant = (): UseMutationResult<DjView, Error, QueueWantVariables> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ slug, channelId, wantId }: QueueWantVariables) =>
      queueWant(slug, channelId, wantId),
    onSuccess: (djView, { slug, channelId }) => {
      queryClient.setQueryData(djViewQueryKey(slug, channelId), djView);
    },
  });
};
